import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRedoToolbar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M18.5 18.8801H2.75C2.05964 18.8801 1.5 18.3205 1.5 17.6301V8.64001C1.5 7.94966 2.05964 7.39001 2.75 7.39001H10.25H18.4453",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.4532 1.85327L19 7.40006L13.4532 12.9468",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeLinecap: "round"
	})]
});
export default SvgRedoToolbar;
